import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { init } from '../../auth/handleTokens';
import { constants } from '../../constants';
import NotificationContext from '../toasts/NotificationContext';

const NewLink = (props) => {
  const toggle = props.toggleSidebar ? '215px' : '10px';
  const [link, setLink] = useState('');
  const [links, setLinks] = useState([]);
  const [nameLink, setNameLink] = useState('');
  const [newLink, setNewLink] = useState(false);
  const {showNotification} = useContext(NotificationContext)

  const getLinks =  async() => {
    
   try {
    const result = await init();
    if(!result) return window.location.href = '/login';
    const token = window.localStorage.getItem('at');
    const URL = constants.test_host + '/sms/links/list';
    const {data} = await axios.get(URL, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true})
    setLinks(data.links);
    
   } catch (error) {
      console.log(error.response.data)
   }
  }

  useEffect(() =>{
    getLinks();
  },[newLink])


const tableLinks = links.map((item, index) =>
  
    <tr key={item._id}>
      <td>{index + 1}</td>
      <td style={{textAlign: 'justify'}}>{item.name}</td>
      <td style={{textAlign: 'justify'}}>{item.url_short}</td>
      <td style={{textAlign: 'justify'}}><a title='Eliminar Link' className='btn-sm btn btn-primary'  id={item._id} ><i className="fas fa-trash-alt"></i></a></td>
    </tr>
)


  const saveLink = async() => {
    try {
      const result = await init('saveLink');
      if(!result) return window.location.href = '/login';
      const URL = constants.test_host + '/sms/createlink';
      const token= window.localStorage.getItem('at');
      const {data} = await axios.post(URL, {name: nameLink, url_long: link}, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true});
      showNotification('success', data.message);
      setNewLink(!newLink);
      setLink('');
      setNameLink('');
      
    } catch (error) {
      showNotification('failed', error.response.message)
    }
  }

  return (
    <div
      className="content-wrapper content"
      style={{ marginLeft: `${toggle}`, transition: "all 0.5s" }}
    >
      <div className="container">
      <h5 className='subtitle'>Links</h5>
        <div className="row d-flex justify-content-left">
          <form className="row g-2">
            <div style={{fontSize: 'medium'}} className="col-auto form-floating form-outline">
              
              <input
                type="text"
                className="form-control"
                id="nameLink"
                name='nameLink'
                required
                value={nameLink}
                onChange= {({target}) => setNameLink(target.value)}
                placeholder= 'Nombre del Link'
                style={{maxHeight: '40px', fontSize:'smaller'}}
              />
              <label style={{fontSize: 'small'}} htmlFor="nameLink">
                Nombra tu Link
              </label>
            </div>
            <div style={{fontSize: 'medium', maxWidth: '600px'}} className="col-11 form-floating form-outline">
              
              <input
                type="text"
                className="form-control"
                id="link"
                name='link'
                required
                value={link}
                onChange= {({target}) => setLink(target.value)}
                placeholder= 'Link'
                style={{maxHeight: '40px', maxWidth:'600px', fontSize:'smaller'}}
              />
              <label style={{fontSize: 'small'}} htmlFor="link">
                Ingresa tu Link
              </label>
            </div>

            <div className="col-auto">
              <button type='button' onClick={saveLink} className="btn btn-sm btn-primary mb-3">
                Guardar
              </button>
            </div>
          </form>
        </div>

        <hr />

          <div>
          <h6 style={{textAlign: 'left', paddingLeft:'20px', fontSize:'smaller'}}>Links Registrados:</h6>
          <table className="table table-striped" style={{fontSize:'small', textAlign: 'justify'}}>
            <thead>
              <tr>
                <th>#Id</th>
                <th>Nombre</th>
                <th>URL Corta</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {tableLinks}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}

export default NewLink
